import React, { useEffect, useState } from 'react';
import { setSessionStorageItem, getSessionStorageItem, SESSION_STORAGE_EMAIL_CAPTURE } from '../../../../sessionStorage';
import SaveQuote from './SaveQuote';
import { saveQuoteMessage } from './SaveQuoteMessage';
import { saveSessionEvent } from '../../../../session';

import './SaveQuotePartnerReferral.scss';

export default function SaveQuotePartnerReferral(props) {

    const title = props.title || "NEEDS ANALYSIS";
    const emailCaptureObj = getSessionStorageItem(SESSION_STORAGE_EMAIL_CAPTURE);

    const [modalSaveQuoteIsOpen, setModalSaveQuoteIsOpen] = useState(false);
    const [saveType, setSaveType] = useState(null);
    const [saveMessage, setSaveMessage] = useState(null);

    const {
        enableInitialEmailCapture, 
        enableTimeoutEmailCapture, 
        initialEmailCaptureDisplayed, 
        timeoutEmailCaptureDisplayed, 
        enablePartnerReferralEmailCapture, 
        isPartnerReferralEmailCaptureActive
    } = props.setEmailModal;

    const handleSaveModalClick = () => {
        if (props.isQuoteSaved) {
            setSaveType("update");
        } else {
            setSaveType(null);
        }
        setModalSaveQuoteIsOpen(true);
    };

    const onSubmit = () => {
        props.onSubmit();
    };

    useEffect(() => {
        if (!props.isActivePurl && isPartnerReferralEmailCaptureActive && enablePartnerReferralEmailCapture) {
            setSaveType("referral");
            setSessionStorageItem("EMAIL_CAPTURE", {
                ...emailCaptureObj, initialEmailCaptureDisplayed: true,
                timeoutEmailCaptureDisplayed: true,
            });
            props.setInitialEmailDisplayed();
        }
    }, []);

    useEffect(() => {
        setModalSaveQuoteIsOpen(props.modalSaveQuoteIsOpen);
        if (props.modalSaveQuoteIsOpen === true) {
            saveSessionEvent(false, "", true);
        }
    }, [props.modalSaveQuoteIsOpen]);

    useEffect(() => {
        props.setModalSaveQuoteIsOpen(modalSaveQuoteIsOpen);
    }, [modalSaveQuoteIsOpen]);


    useEffect(() => {
        const email = props.saveQuoteData ? props.saveQuoteData.emailAddress : "";
        const message = saveQuoteMessage(saveType, email);
        setSaveMessage(message, email);
    }, [saveType, props.saveQuoteData]);

    const modalSaveTermQuoteFields = {
        modalSaveQuoteIsOpen: modalSaveQuoteIsOpen,
        setModalSaveQuoteIsOpen: setModalSaveQuoteIsOpen,
        loading: props.loading,
        quoteLogId: props.quoteLogId,
        errorMessage: props.errorMessage,
        setErrorMessage: props.setErrorMessage,
    };

    return (
        <div className="save-term-quote-btn">
            <React.Fragment>
                <SaveQuote 
                    setEmailPrefill={(e) => props.setEmailPrefill(e)}
                    fields={modalSaveTermQuoteFields} 
                    saveMessage={saveMessage} 
                    saveQuoteData={props.saveQuoteData}
                    setQuoteSaved={props.setQuoteSaved}
                    isQuoteSaved={props.isQuoteSaved}
                    onSubmit={onSubmit}
                    handleContactChange={(e) => props.handleContactChange(e)}/>
            </React.Fragment>
        </div>
    );
}